/**
 * Modal de confirmation projet (style unifié, remplace window.confirm).
 */
export function initProjectConfirmModal(modalId = 'cc-project-confirm') {
    const confirmModal = document.getElementById(modalId);
    if (!confirmModal) {
        return null;
    }

    const messageEl = confirmModal.querySelector('.cc-project-confirm__message');
    const okBtn = confirmModal.querySelector('[data-confirm-ok]');
    const cancelBtn = confirmModal.querySelector('[data-confirm-cancel]');
    const backdrop = confirmModal.querySelector('[data-confirm-dismiss]');

    if (!messageEl || !okBtn || !cancelBtn || !backdrop) {
        return null;
    }

    let pendingConfirm = null;

    function closeProjectConfirm(result) {
        confirmModal.hidden = true;
        confirmModal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('cc-project-confirm-open');

        if (pendingConfirm) {
            const resolve = pendingConfirm;
            pendingConfirm = null;
            resolve(result);
        }
    }

    function confirmOpen(message) {
        return new Promise(function (resolve) {
            pendingConfirm = resolve;
            messageEl.textContent = message;
            confirmModal.hidden = false;
            confirmModal.setAttribute('aria-hidden', 'false');
            document.body.classList.add('cc-project-confirm-open');
            cancelBtn.focus();
        });
    }

    okBtn.addEventListener('click', function () {
        closeProjectConfirm(true);
    });
    cancelBtn.addEventListener('click', function () {
        closeProjectConfirm(false);
    });
    backdrop.addEventListener('click', function () {
        closeProjectConfirm(false);
    });
    confirmModal.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            closeProjectConfirm(false);
        }
    });

    return confirmOpen;
}
